import useReadOffline from "../../../../framework/connectors/read-offline/useReadOffline";
import React, { useEffect, useState } from "react";
import QRDownloadApps from "./index";
import { noticeInteraction } from "../../../../../../services/monitoring";

const SHOW_QR_DIALOG_EVENT = "download-app-show-qr-dialog";

export function useGeneralDownloadAppButton(analyticEventName?: string) {
  const {
    readOfflineEnabled,
    readOfflineQrCodeSupported,
    downloadApp,
  } = useReadOffline();

  function readOfflineOnClick() {
    if (readOfflineQrCodeSupported) {
      window.dispatchEvent(new CustomEvent(SHOW_QR_DIALOG_EVENT));
    } else {
      downloadApp();
    }
    if (analyticEventName) {
      noticeInteraction(analyticEventName);
    }
  }

  return {
    readOfflineEnabled,
    readOfflineHref: !readOfflineQrCodeSupported ? "#" : undefined,
    readOfflineOnClick,
  };
}

export function GeneralDownloadApp() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    function onDialogShow() {
      setIsDialogOpen(true);
    }
    window.addEventListener(SHOW_QR_DIALOG_EVENT, onDialogShow);
    return () => {
      window.removeEventListener(SHOW_QR_DIALOG_EVENT, onDialogShow);
    };
  }, []);

  return (
    <QRDownloadApps
      open={isDialogOpen}
      onRequestClose={() => setIsDialogOpen(false)}
    />
  );
}
